var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIconHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 38,
    height: 38,
    rx: 4,
    stroke: "#A79FBD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9041 18.2575C30.1301 16.9748 27.9502 16.2188 25.5938 16.2188C19.6394 16.2188 14.8125 21.0457 14.8125 27C14.8125 32.9543 19.6394 37.7812 25.5938 37.7812C27.9502 37.7812 30.1301 37.0252 31.9041 35.7425",
    stroke: "#A79FBD",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 27L38.2308 27",
    stroke: "#A79FBD",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 22.7812L39.897 27L36.375 31.2188",
    stroke: "#A79FBD",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconHovered);
export default __webpack_public_path__ + "static/media/Logout_icon_hovered.865a28d442acdf246ac1ae4e0c8c87e2.svg";
export { ForwardRef as ReactComponent };